<div class="relative z-[5]">
  <div class="relative">
    <div class="input-icon">
      <i-lucide
        [name]="searchIcon"
        size="24"
        class="text-slate-400 dark:text-dark-muted absolute"
        [ngClass]="[config?.standalone ? 'left-2 top-1.5' : 'left-4 top-5']"
      ></i-lucide>
    </div>
    <input
      #searchInput
      type="search"
      [placeholder]="(searchConfig.placeholder || '-') | translate"
      class="flex px-8 items-center font-normal text-sm pr-4 w-full focus:border-theme-primary text-gray-600 dark:text-gray-400 placeholder-gray-400 search-input dark:bg-dark-input"
      [ngClass]="[config?.standalone ? 'border border-slate-300 rounded-lg pl-10 py-2' : 'border-none pl-16 py-6']"
      [formControl]="searchForm"
      (click)="value.length >= 2 && searchOverlayMenu ? searchOverlayMenu.visible = true : null"
    />
    @if (searchConfig.hotkeys) {
      <div class="absolute top-5 right-3 rounded-md bg-gray-100 dark:bg-dark-hover text-gray-500 dark:text-dark-muted font-semibold text-xs block p-2">⌘+K</div>
    }

  </div>
  @if (searchConfig.callBackFunction) {
    <app-overlay-menu
      #searchOverlayMenu
      [collection]="searchResultCollection"
      [visible]="value.length >= 2"
      [searchQuery]="value"
      [loading]="loading"
      [loadFailed]="loadFailed"
      [loadNotFound]="loadNotFound"
      [canGoBack]="canGoBack"
      (elementClicked)="searchResultClicked($event)"
      (focusedElement)="elementFocus = $event"
      (goBack)="goBack()"
      (retry)="loadResults()"
    ></app-overlay-menu>
  }
</div>
